import React, {Fragment} from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'
import SimilarProductsSlider from './similar-products-slider'

const SimilarProducts = ({response, id}) => {
  const {data} = response;

  let sliderData = [];
  if (data) {
    sliderData = data.filter(item => item.id !== parseInt(id))
  }

  return (
    <Fragment>
      {sliderData.length &&
      (<section className="product-card__similar-products-slider">
        <h3>Похожие товары:</h3>
        <SimilarProductsSlider sliderData={sliderData}
                               countOfViewed={3}/>
      </section>)
      }
    </Fragment>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProducts
  };
};

export default withApiService(mapMethodsToProps)(withData(SimilarProducts))
